// extracted by mini-css-extract-plugin
export var rssCategories = "rss-parser-module--rss-categories--4393f";
export var rssContent = "rss-parser-module--rss-content--5d7d5";
export var rssImage = "rss-parser-module--rss-image--da32a";
export var rssTitle = "rss-parser-module--rss-title--07b10";